import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const ChecklistPen: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_33495)'>
        <path
          d='M11.7034 20.6402H3.42986C2.59346 20.6402 1.91358 19.9594 1.91358 19.123V3.46118C1.91358 2.62478 2.59346 1.9449 3.42986 1.9449H15.9921C16.8285 1.9449 17.5084 2.62478 17.5084 3.46118V10.2185C17.5084 10.4712 17.713 10.6748 17.9648 10.6748C18.2175 10.6748 18.4212 10.4702 18.4212 10.2185L18.4221 3.46118C18.4221 2.12122 17.332 1.03125 15.9922 1.03125H3.42993C2.08997 1.03125 1 2.12132 1 3.46118V19.124C1 20.4649 2.09007 21.5539 3.42993 21.5539H11.7034C11.9562 21.5539 12.1598 21.3493 12.1598 21.0975C12.1598 20.8448 11.9552 20.6411 11.7034 20.6411L11.7034 20.6402Z'
          fill='url(#paint0_linear_12280_33495)'
          stroke='url(#paint1_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M15.2834 4.49609H8.3685C8.11578 4.49609 7.91211 4.70072 7.91211 4.95249C7.91211 5.20521 8.11674 5.40888 8.3685 5.40888H15.2834C15.5361 5.40888 15.7398 5.20425 15.7398 4.95249C15.7398 4.69976 15.5352 4.49609 15.2834 4.49609Z'
          fill='url(#paint2_linear_12280_33495)'
          stroke='url(#paint3_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M15.2834 8.67578H8.3685C8.11578 8.67578 7.91211 8.88041 7.91211 9.13217C7.91211 9.38489 8.11674 9.58856 8.3685 9.58856H15.2834C15.5361 9.58856 15.7398 9.38394 15.7398 9.13217C15.7398 8.87945 15.5352 8.67578 15.2834 8.67578Z'
          fill='url(#paint4_linear_12280_33495)'
          stroke='url(#paint5_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M7.06663 3.80945C6.88841 3.63123 6.59986 3.63123 6.42069 3.80945L5.09393 5.13527L4.46402 4.5063C4.2858 4.32902 3.99631 4.32808 3.81714 4.50724C3.63892 4.68546 3.63892 4.97495 3.81808 5.15412L4.77142 6.10652C4.861 6.19516 4.97793 6.23947 5.09485 6.23947C5.21177 6.23947 5.32871 6.19516 5.41828 6.10557L7.06752 4.45633C7.24575 4.27811 7.24575 3.98861 7.06752 3.81039L7.06663 3.80945Z'
          fill='url(#paint6_linear_12280_33495)'
          stroke='url(#paint7_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M7.06663 12.1644C6.88841 11.9872 6.59892 11.9862 6.41975 12.1654L5.09393 13.4921L4.46402 12.8632C4.2858 12.6859 3.99631 12.685 3.81714 12.8641C3.63892 13.0423 3.63892 13.3318 3.81808 13.511L4.77142 14.4634C4.861 14.552 4.97793 14.5964 5.09485 14.5964C5.21177 14.5964 5.32965 14.552 5.41828 14.4625L7.06752 12.8123C7.24575 12.634 7.24575 12.3446 7.06658 12.1654L7.06663 12.1644Z'
          fill='url(#paint8_linear_12280_33495)'
          stroke='url(#paint9_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M15.7398 13.3119C15.7398 13.0591 15.5352 12.8555 15.2834 12.8555H8.3685C8.11578 12.8555 7.91211 13.0601 7.91211 13.3119C7.91211 13.5646 8.11674 13.7683 8.3685 13.7683H15.2834C15.5361 13.7683 15.7398 13.5636 15.7398 13.3119Z'
          fill='url(#paint10_linear_12280_33495)'
          stroke='url(#paint11_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M6.72386 7.85242C6.54564 7.67419 6.25709 7.67419 6.07792 7.85242L5.44048 8.48986L4.80304 7.85242C4.62482 7.67419 4.33627 7.67419 4.1571 7.85242C3.97888 8.03064 3.97888 8.32013 4.1571 8.49835L4.79454 9.1358L4.1571 9.77324C3.97888 9.95146 3.97888 10.241 4.1571 10.4192C4.24668 10.5088 4.36361 10.5531 4.48053 10.5531C4.59746 10.5531 4.71439 10.5088 4.80396 10.4192L5.4414 9.78173L6.07884 10.4192C6.16842 10.5088 6.28535 10.5531 6.40227 10.5531C6.51919 10.5531 6.63613 10.5088 6.7257 10.4192C6.90392 10.241 6.90392 9.95146 6.7257 9.77324L6.08826 9.1358L6.7257 8.49835C6.90392 8.32013 6.90392 8.03064 6.7257 7.85242H6.72386Z'
          fill='url(#paint12_linear_12280_33495)'
          stroke='url(#paint13_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M8.36655 17.043C8.11383 17.043 7.91016 17.2476 7.91016 17.4994C7.91016 17.7521 8.11478 17.9558 8.36655 17.9558H13.2341C13.4869 17.9558 13.6905 17.7511 13.6905 17.4994C13.6905 17.2466 13.4859 17.043 13.2341 17.043H8.36655Z'
          fill='url(#paint14_linear_12280_33495)'
          stroke='url(#paint15_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M6.72386 16.2157C6.54564 16.0375 6.25709 16.0375 6.07792 16.2157L5.44048 16.8531L4.80304 16.2157C4.62482 16.0375 4.33627 16.0375 4.1571 16.2157C3.97888 16.3939 3.97888 16.6834 4.1571 16.8616L4.79454 17.4991L4.1571 18.1365C3.97888 18.3147 3.97888 18.6042 4.1571 18.7825C4.24668 18.872 4.36361 18.9164 4.48053 18.9164C4.59746 18.9164 4.71439 18.872 4.80396 18.7825L5.4414 18.145L6.07884 18.7825C6.16842 18.872 6.28535 18.9164 6.40227 18.9164C6.51919 18.9164 6.63613 18.872 6.7257 18.7825C6.90392 18.6042 6.90392 18.3147 6.7257 18.1365L6.08826 17.4991L6.7257 16.8616C6.90392 16.6834 6.90392 16.3939 6.7257 16.2157H6.72386Z'
          fill='url(#paint16_linear_12280_33495)'
          stroke='url(#paint17_linear_12280_33495)'
          strokeWidth='0.5'
        />
        <path
          d='M22.4047 11.7616L20.88 10.7715C20.5886 10.5801 20.2368 10.5131 19.8965 10.5895C19.5551 10.6621 19.2618 10.8629 19.0723 11.1553L13.6229 19.5478C13.2948 20.0532 13.1326 20.6369 13.1543 21.2376L13.2335 23.5281C13.2391 23.6771 13.3165 23.8147 13.4409 23.8958C13.5164 23.9449 13.6031 23.9694 13.6899 23.9694C13.7474 23.9694 13.8058 23.959 13.8615 23.9364L15.986 23.0773C16.5424 22.852 17.0101 22.4663 17.3392 21.9618L22.7895 13.5693C23.1808 12.9648 23.0083 12.1548 22.4048 11.7625L22.4047 11.7616ZM16.5725 21.463C16.3462 21.81 16.0256 22.074 15.6437 22.2287L14.1245 22.8435L14.067 21.2056C14.0519 20.7935 14.1642 20.3927 14.3886 20.0457L18.8525 13.1706L21.0365 14.5898L16.5725 21.4642L16.5725 21.463ZM22.0219 13.0714L21.5344 13.8221L19.3505 12.4038L19.838 11.6532C19.8955 11.5655 19.9832 11.5052 20.0859 11.4825C20.1133 11.4769 20.1406 11.4741 20.1689 11.4741C20.2444 11.4741 20.3179 11.4957 20.382 11.5372L21.9068 12.5274C22.0888 12.6452 22.1407 12.8895 22.0228 13.0705L22.0219 13.0714Z'
          fill='url(#paint18_linear_12280_33495)'
          stroke='url(#paint19_linear_12280_33495)'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_33495'
          x1='4.60772'
          y1='2.43066'
          x2='14.8344'
          y2='19.8311'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_33495'
          x1='4.60772'
          y1='2.43066'
          x2='14.8344'
          y2='19.8311'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_33495'
          x1='9.53304'
          y1='4.55834'
          x2='9.59342'
          y2='5.59606'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_33495'
          x1='9.53304'
          y1='4.55834'
          x2='9.59342'
          y2='5.59606'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_33495'
          x1='9.53304'
          y1='8.73802'
          x2='9.59342'
          y2='9.77575'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_33495'
          x1='9.53304'
          y1='8.73802'
          x2='9.59342'
          y2='9.77575'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_33495'
          x1='4.41201'
          y1='3.8506'
          x2='5.35125'
          y2='6.43355'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_33495'
          x1='4.41201'
          y1='3.8506'
          x2='5.35125'
          y2='6.43355'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_33495'
          x1='4.41198'
          y1='12.2062'
          x2='5.35217'
          y2='14.7902'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_33495'
          x1='4.41198'
          y1='12.2062'
          x2='5.35217'
          y2='14.7902'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_33495'
          x1='9.53304'
          y1='12.9177'
          x2='9.59342'
          y2='13.9554'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_33495'
          x1='9.53304'
          y1='12.9177'
          x2='9.59342'
          y2='13.9554'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint12_linear_12280_33495'
          x1='4.61069'
          y1='7.91202'
          x2='5.90188'
          y2='10.5014'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint13_linear_12280_33495'
          x1='4.61069'
          y1='7.91202'
          x2='5.90188'
          y2='10.5014'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint14_linear_12280_33495'
          x1='9.10714'
          y1='17.1052'
          x2='9.18867'
          y2='18.14'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint15_linear_12280_33495'
          x1='9.10714'
          y1='17.1052'
          x2='9.18867'
          y2='18.14'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint16_linear_12280_33495'
          x1='4.61069'
          y1='16.2753'
          x2='5.90188'
          y2='18.8647'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint17_linear_12280_33495'
          x1='4.61069'
          y1='16.2753'
          x2='5.90188'
          y2='18.8647'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint18_linear_12280_33495'
          x1='15.1914'
          y1='11.4731'
          x2='22.303'
          y2='21.9387'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint19_linear_12280_33495'
          x1='15.1914'
          y1='11.4731'
          x2='22.303'
          y2='21.9387'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_33495'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChecklistPen;
